



















import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class Help extends Mixins(GlobalMixin) {
  /**
   * 操作説明書ダウンロード
   */
  onManualDownload() {
    const a = document.createElement('a')
    a.href = "/pdf/manual.pdf"
    a.download = "操作説明書.pdf"
    document.body.appendChild(a)
    a.click()
    a.remove()
  }
}
